import MemberFilter from 'components/brokers/needs_attention/MemberFilter'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'

const MembersFilter = (props: MultipleSelectedValuesFilter) => {
  return <MemberFilter {...props} />
}

export default MembersFilter
